import Env from "../base/env";
import Component from "gia/Component";
import { RevealScaleOut } from "../fx/Common";

export default class FxModule extends Component {
  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    //? Fns
    setTimeout(() => {
      RevealScaleOut(this.DOM.view);
    }, Env.timingDelayFx);
  }
}
